import { MantineThemeOverride } from '@mantine/core';

export type PinInputTheme = NonNullable<MantineThemeOverride['components']>['PinInput'];

export const PinInput: PinInputTheme = {
  // todo: define
};
